export default {
    user: {
        create: {
            title: "Nuevo usuario",
            model: {
                email: {
                    label: "Correo electrónico",
                    placeholder: "Completar correo electrónico"
                },
                name: {
                    label: "Nombre",
                    placeholder: "Complete el nombre"
                },
                country: {
                    label: "País",
                    placeholder: "Completar país"
                },
                approval_manager_email: {
                    label: "Correo electrónico del gerente",
                    placeholder: "Completar el correo electrónico del administrador",
                    errors: {
                        different: "El correo electrónico del administrador de aprobaciones debe ser diferente del correo electrónico del usuario"
                    }
                }
            },
            cta: {
                submit: {
                    text: "Entregar",
                    processing: "Sumisión"
                },
                cancel: {
                    text: "Cancelar"
                }
            }
        },
        country: {
            title: "País del usuario",
            header: "{email} no tiene ningún país seleccionado. Por favor, seleccione su país.",
            model: {
                country: {
                    label: "País",
                    placeholder: "Completar país"
                }
            },
            cta: {
                submit: {
                    text: "Entregar",
                    processing: "Sumisión"
                },
                cancel: {
                    text: "Cancelar"
                }
            }
        }
    }
}